import { GeneralModel } from "./general.model";
import { Hub } from "./hub.model";

export class AreaC extends GeneralModel {
    poHubId: number;
    poHub: Hub;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/models/areac.model.ts